import {
  illustrationGlowBottomClassName,
  illustrationGlowClassName,
  illustrationGlowTopClassName,
  illustrationPanelClassName,
} from '@/components/step-flow/StepFlowShell.styles';
import type { IllustrationPanelProps } from '@/components/step-flow/StepFlowShell.types';
import { Box, cn } from '@careflux/primitives';

export const IllustrationPanel = ({ children }: IllustrationPanelProps) => (
  <Box
    as="aside"
    aria-hidden="true"
    display={{ base: 'none', lg: 'flex' }}
    align="center"
    justify="center"
    position="relative"
    overflow="hidden"
    rounded="xl"
    marginY="md"
    marginRight="md"
    background="accent"
    className={illustrationPanelClassName}
  >
    <Box
      position="absolute"
      pointerEvents="none"
      rounded="full"
      className={cn(illustrationGlowClassName, illustrationGlowTopClassName)}
    />
    <Box
      position="absolute"
      pointerEvents="none"
      rounded="full"
      className={cn(illustrationGlowClassName, illustrationGlowBottomClassName)}
    />
    <Box position="relative">{children}</Box>
  </Box>
);
